import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { isTrash } from '../helpers/App';

const TrashHeader = () => {
  const intl = useIntl();
  const location = useLocation();
  const [searchParamsString, setSearchParamsString] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setSearchParamsString(searchParams.toString());
  }, [location]);

  if (!isTrash()) {
    return null;
  }

  return (
    <div className="trash-header">
      {intl.formatMessage({
        defaultMessage: 'You are browsing the trash',
      })}
      <Link to={`/files?${searchParamsString}`}>
        {intl.formatMessage({
          defaultMessage: 'Return to files list',
        })}
      </Link>
    </div>
  );
};

export default TrashHeader;
